// package imports
import React, { useState } from 'react';
import Cookies from 'universal-cookie';

// CSS imports
import './Login.css';

// Component imports
import PrimaryButton from '../../buttons/primaryButton/PrimaryButton';
import TransparentButton from '../../buttons/transparentButton/TransparentButton';
import Alert from '../../alert/Alert';

// Service imports
import { ApiService } from '../../../services/ApiService';

// Image imports
import GoogleLogo from '../../../assets/images/google.svg';

// Icon imports
import { FiMail } from 'react-icons/fi';
import { MdError } from 'react-icons/md';

// Type imports
import { LoginPage } from '../../../types/login/LoginPage';
import { AlertSize } from '../../../types/alert/AlertSize';

// Special imports
import { config } from '../../../config';

type Props = {
  switchPage: (x: LoginPage) => void;
  setIsLoading: (x: boolean) => void;
};

const Login: React.FC<Props> = ({ switchPage, setIsLoading }: Props) => {
  const [showUnknownError, setShowUnknownError] = useState(false);

  const triggerGoogleLogin = async () => {
    const pathname = window.location.pathname;
    const cookies = new Cookies();
    cookies.set('googleAuthPathname', pathname, {
      path: '/',
      expires: new Date(Date.now() + 60 * 60 * 1 * 1000),
    });
    cookies.set('googleAuthTriggerPage', 'login', {
      path: '/',
      expires: new Date(Date.now() + 60 * 60 * 1 * 1000),
    });

    setIsLoading(true);

    const requestUrl = await ApiService.googleAuthRequest('login');
    window.location.href = requestUrl;

    // if (res) {
    //   window.location.href = res.googleUrl;
    // } else {
    //   setIsLoading(false);
    //   setShowUnknownError(true);
    // }
  };

  return (
    <div className='Login'>
      <h1>Log in</h1>
      <PrimaryButton
        className='full-width'
        label='Log in with Google'
        imgIcon={GoogleLogo}
        onClick={triggerGoogleLogin}
      />
      <div className='other-options-container'>
        <TransparentButton
          ReactIcon={FiMail}
          onClick={() => switchPage(LoginPage.EMAILLOGIN)}
        />
      </div>
      <span>
        New to {config.appName}?{' '}
        <span
          className='create-link'
          onClick={() => switchPage(LoginPage.SIGNUP)}
        >
          Create an account
        </span>
      </span>
      <Alert
        showAlert={showUnknownError}
        size={AlertSize.SMALL}
        time={3000}
        setShowAlert={setShowUnknownError}
      >
        <MdError size={20} />
        <span>Something went wrong!</span>
      </Alert>
    </div>
  );
};

export default Login;
